import {Select} from "antd";
import {FormField} from "../../../../../design-system/form-field";
import {Controller, useFormContext} from "react-hook-form";
import type {CreateSessionBasicFormStepFormValues} from "../../multi-step/basic-form/schema-validation";

export const CallDurationOptions = [
  {
    label: "15 Minutes",
    value: "15",
  },
  {
    label: "30 Minutes",
    value: "30",
  },
  {
    label: "45 Minutes",
    value: "45",
  },
  {
    label: "60 Minutes",
    value: "60",
  },
  {
    label: "Custom",
    value: "-1",
  },
];

export function ServiceFormCallDurationFormField() {
  const {control} = useFormContext<CreateSessionBasicFormStepFormValues>();

  return (
    <div>
      <FormField
        id="serviceCallDuration"
        label="Call Duration"
        renderInput={(id) => (
          <Controller
            control={control}
            name="callDuration"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <div>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={onChange}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  options={CallDurationOptions}
                  placeholder="Please select a duration"
                />
                {error?.message && (
                  <div role="alert" className="ant-form-item-explain-error">
                    {error.message}
                  </div>
                )}
              </div>
            )}
          />
        )}
      />
    </div>
  );
}
